import { FormControl, FormHelperText, MenuItem, Select } from "@mui/material";
import { Controller, useFormState } from "react-hook-form";

export function SelectField({
  name,
  options,
  multiple = false,
  disabledOptions = [],
}: {
  name: string;
  options: string[] | { label: string; value: string }[];
  multiple?: boolean;
  disabledOptions?: string[];
}) {
  const { errors } = useFormState();
  const error = errors[name];

  return (
    <FormControl error={!!error} fullWidth>
      <Controller
        name={name}
        render={({ field }) => (
          <>
            <Select
              {...field}
              fullWidth
              multiple={multiple}
              defaultValue={multiple ? [] : ""}
              value={field.value ?? (multiple ? [] : "")}
            >
              {options.map((option) => {
                if (typeof option === "string") {
                  return (
                    <MenuItem
                      disabled={disabledOptions.includes(option)}
                      key={option}
                      value={option}
                    >
                      {option}
                    </MenuItem>
                  );
                }

                return (
                  <MenuItem
                    disabled={disabledOptions.includes(option.value)}
                    key={option.value}
                    value={option.value}
                  >
                    {option.label}
                  </MenuItem>
                );
              })}
            </Select>
            {error && (
              <FormHelperText>{error.message?.toString()}</FormHelperText>
            )}
          </>
        )}
      />
    </FormControl>
  );
}
